import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    ctaSubmit: 'Next',
    description: {
      mandate:
        'This information should be identical to that indicated in the draft statutes.',
      nonMandate:
        'This information should be identical to that indicated in your draft statutes.',
    },
    legalNumberOfShares: {
      helpDescription: {
        mandate:
          'Shares are the titles of ownership of a company’s capital. They are divided between partners in proportion to their investment. This distribution is specified in the draft statutes.\n\n' +
          'Here, you must indicate the total number of shares and not the number of partners.',
        nonMandate:
          'Shares are the titles of ownership of a company’s capital. They are divided between partners in proportion to their investment. This distribution is specified in your draft statutes.\n\n' +
          'Here, you must indicate the total number of shares and not the number of partners.',
      },
      helpTitle: 'What is the number of shares?',
      invalidError: 'Please enter a whole number',
      label: 'Number of shares',
      minValueError: 'The number of shares cannot be less that {minimumNumber}',
      placeholder: '10, 25, 100...',
    },
    legalShareCapital: {
      helpDescription:
        'The share capital of the company is the sum of assets brought by shareholders and/or founding partners. It can be money, tangible or intangible assets (i.e software, patents, ...).',
      helpTitle: 'What is the share capital',
      invalidError: 'Please enter a whole number',
      label: 'Share capital (in €)',
      minValueError: 'The minimum capital is {minimumAmount}',
      placeholder: 'Amount in €',
    },
    paidUpCapitalPercentage: {
      defaultLabel: 'Percentage of capital released',
      hintPercentage: 'Enter the number without the % sign',
      hintTwentyPercent: 'Accepted for SARL, SELARL and Société Civile',
      integerError: 'Please enter a percentage without decimals',
      invalidError: 'Please enter a percentage',
      label: 'Percentage of paid-up capital',

      numberError: 'Enter a number',

      other: 'Other',

      otherPlaceholder: '30, 40, 75...',

      placeholder: 'Share of capital in %',
      rangeError: 'Enter a number between 1 et 100',
      rangeErrorAboveFiftyPercent:
        'Pour une SAS, enter a number between 50 and 100',
      rangeErrorAboveTwentyPercent:
        'For a SARL, enter a number between 20 and 100',
      warning:
        '**{paidUpCapital}** will have to be deposited in order to get the deposit certificate.',
    },
    title: {
      mandate: 'The capital of the company',
      nonMandate: 'The capital of your company',
    },
  },
  fr: {
    ctaSubmit: 'Suivant',
    description: {
      mandate:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de la société.',
      nonMandate:
        'Ces informations doivent correspondre exactement à celles qui figurent dans le projet de statuts de votre société.',
    },
    legalNumberOfShares: {
      helpDescription: {
        mandate:
          'Les parts sociales sont des titres de propriété sur le capital de la société. Ils sont divisés entre associé·es proportionnellement au montant des apports réalisés, et cette répartition est précisée dans le projet de statuts.\n\n' +
          'Ici, vous devez indiquer le nombre total de parts et non le nombre d’associé·es.',
        nonMandate:
          'Les parts sociales sont des titres de propriété sur le capital de la société. Ils sont divisés entre associé·es proportionnellement au montant des apports réalisés, et cette répartition est précisée dans votre projet de statuts.\n\n' +
          'Ici, vous devez indiquer le nombre total de parts et non le nombre d’associé·es.',
      },
      helpTitle: 'Qu’est-ce que le nombre de parts\u00A0?',
      invalidError: 'Veuillez renseigner un nombre entier',
      label: 'Nombre de parts',
      minValueError:
        'Le nombre de parts ne peut pas être inférieur à {minimumNumber}',
      placeholder: '10, 25, 100...',
    },
    legalShareCapital: {
      helpDescription:
        'Le capital représente les sommes apportées par les actionnaires ou les associés fondateurs de la société. Ce capital peut prendre la forme d’argent, ou alors de biens matériels ou immatériels (logiciels ou brevets par exemple).',
      helpTitle: 'Qu’est ce qu’un capital social\u00A0?',
      invalidError: 'Veuillez renseigner un nombre entier',
      label: 'Capital social total (en €)',
      minValueError:
        'Le montant minimum du capital social est de {minimumAmount}',
      placeholder: 'Montant en €',
    },
    paidUpCapitalPercentage: {
      defaultLabel: 'Capital versé lors de l’ouverture du compte',
      hintPercentage: 'Saisir le chiffre sans le %',
      hintTwentyPercent: 'Accepté pour les SARL, SELARL et Société Civile',
      integerError: 'Veuillez saisir un pourcentage sans virgule',
      invalidError: 'Veuillez renseigner un pourcentage',
      label: 'Pourcentage du capital versé',

      numberError: 'Saisissez un nombre',

      other: 'Autre',

      otherPlaceholder: '30, 40, 75...',

      placeholder: 'Part du capital en %',
      rangeError: 'Saisissez un nombre entre 1 et 100',
      rangeErrorAboveFiftyPercent:
        'Pour une SAS, saisissez un nombre entre 50 et 100',
      rangeErrorAboveTwentyPercent:
        'Pour une SARL, saisissez un nombre entre 20 et 100',
      warning:
        '**{paidUpCapital}** seront donc à verser afin d’obtenir le certificat de dépôt.',
    },
    title: {
      mandate: 'Le capital de l’entreprise',
      nonMandate: 'Le capital de votre entreprise',
    },
  },
} as const);
